/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * RoutesStatsDetailDtoBase
 * auto generated base class for the model RoutesStatsDetailDtoModel.
 *
 * Aggregate Routes Details
 */
export const RoutesStatsDetailDtoModelBase = ModelBase
  .named('RoutesStatsDetailDto')
  .props({
    __typename: types.optional(types.literal("RoutesStatsDetailDto"), "RoutesStatsDetailDto"),
    /** Total working time in minutes aggregated across all routes */
    workingTime: types.union(types.undefined, types.number),
    /** Total idle time in minutes aggregated across all routes */
    totalIdleTime: types.union(types.undefined, types.integer),
    /** Total load aggregated across all routes */
    load: types.union(types.undefined, types.number),
    /** Total duration aggregated across all routes */
    totalDuration: types.union(types.undefined, types.integer),
    /** Total available capacity aggregated across all routes */
    totalCapacity: types.union(types.undefined, types.null, types.number),
    /** Total distance (in metres) aggregated across all routes */
    distance: types.union(types.undefined, types.number),
    /** Total stops count aggregated across all routes */
    stopsCount: types.union(types.undefined, types.integer),
    /** Total orders count aggregated across all routes */
    ordersCount: types.union(types.undefined, types.integer),
    /** Total routes count aggregated for that date */
    routesCount: types.union(types.undefined, types.integer),
    /** Whether any route has working time exceeding shift duration */
    isOvertime: types.union(types.undefined, types.boolean),
    /** Whether any route has load exceeding capacity */
    isOverCapacity: types.union(types.undefined, types.boolean),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class RoutesStatsDetailDtoModelSelector extends QueryBuilder {
  get workingTime() { return this.__attr(`workingTime`) }
  get totalIdleTime() { return this.__attr(`totalIdleTime`) }
  get load() { return this.__attr(`load`) }
  get totalDuration() { return this.__attr(`totalDuration`) }
  get totalCapacity() { return this.__attr(`totalCapacity`) }
  get distance() { return this.__attr(`distance`) }
  get stopsCount() { return this.__attr(`stopsCount`) }
  get ordersCount() { return this.__attr(`ordersCount`) }
  get routesCount() { return this.__attr(`routesCount`) }
  get isOvertime() { return this.__attr(`isOvertime`) }
  get isOverCapacity() { return this.__attr(`isOverCapacity`) }
}
export function selectFromRoutesStatsDetailDto() {
  return new RoutesStatsDetailDtoModelSelector()
}

export const routesStatsDetailDtoModelPrimitives = selectFromRoutesStatsDetailDto().workingTime.totalIdleTime.load.totalDuration.totalCapacity.distance.stopsCount.ordersCount.routesCount.isOvertime.isOverCapacity
